// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React, { useState } from 'react';
import { Row, Col } from 'antd/lib/grid';
import Pagination from 'antd/lib/pagination';
import dimensions from 'utils/dimensions';
import RunJobItemComponent from './run-job-item';

interface Props {
    task: any;
    runId: number;
    qaStates: Record<number, string>;
}

const PAGE_SIZE = 10;

export default function JobListComponent({ task, runId, qaStates }: Props): JSX.Element {
    const [page, setPage] = useState(1);
    const jobs: any[] = [...(task.jobs || [])].sort((a: any, b: any) => a.id - b.id);
    const pageJobs = jobs.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    return (
        <Row justify='center' align='top' className='cvat-run-job-list' style={{ marginTop: 16 }}>
            <Col {...dimensions}>
                {pageJobs.map((job: any) => (
                    <RunJobItemComponent
                        key={job.id}
                        job={job}
                        runId={runId}
                        taskId={task.id}
                        qaState={qaStates[job.id] || 'new'}
                    />
                ))}
                {jobs.length > PAGE_SIZE && (
                    <Row justify='center' style={{ marginTop: 16 }}>
                        <Pagination
                            current={page}
                            pageSize={PAGE_SIZE}
                            total={jobs.length}
                            onChange={setPage}
                            showSizeChanger={false}
                        />
                    </Row>
                )}
            </Col>
        </Row>
    );
}
